export const VERSION = '0.2.1'
export const MAX_FETCH_TIME = 2000